import { Link } from 'react-router';
import { tx } from '../i18n';

/** Una dirección que no es de ninguna pantalla: se dice, no se deja la página en blanco. */
export function NoExiste() {
  return (
    <div className="pagina">
      <div className="panel no-existe">
        <h1>{tx.noExiste.titulo}</h1>
        <p className="nota">{tx.noExiste.que}</p>
        <Link className="btn prim" to="/">
          {tx.noExiste.alTablero}
        </Link>
      </div>
    </div>
  );
}
